<div class="content-wrap">
  <div class="content">
    <span>Gracias!</span>
    <div>
      <p>
        Hartelijk dank voor de genomen moeite. Wij zullen een persoonlijke TOP5
        voor u samenstellen en deze mailen. Het kan zijn dat deze in uw spam
        terecht komt, gelieve ook deze mailbox te controleren. Op werkdagen
        ontvangt u uw TOP5 binnen 24 uur van ons.
      </p>
      <hr />
      <svg
        width="56"
        height="56"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="12" fill="#3D943C" />
        <g clip-path="url(#clip0)">
          <path d="M7 12L10.5 15.5L17 9" stroke="white" stroke-width="2" />
        </g>
        <defs>
          <clipPath id="clip0">
            <rect x="0" y="0" width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  </div>
  <div
    class="bg"
    style={`background: url(${window.zoekModalOptions.complete_image});`} />
</div>

<style lang="postcss">
  .content {
    box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.1);
    @apply relative mx-5 mt-16 p-12 pt-8 z-10 bg-white;
  }

  span {
    @apply text-2xl;
  }

  p {
    @apply mt-5;
  }

  hr {
    @apply border-dashed mt-5;
  }

  svg {
    @apply mx-auto mt-16;
  }

  .bg {
    /* background: url(/wp-content/themes/puurspanje/zoekprofiel/assets/image59.png); */
    background-size: cover;
    padding-bottom: 77%;
    @apply relative z-0 -mt-10;
  }

  @screen sm {
    .content {
      @apply mx-12 p-16 w-4/6;
    }
    .content > div {
      @apply flex items-center;
    }
    p {
      @apply pr-16;
    }
    svg {
      @apply mt-0 flex-shrink-0;
    }
    hr {
      @apply hidden;
    }
    .bg {
      @apply -mt-32 mx-12;
    }
  }

  @screen md {
    .content-wrap {
      @apply flex items-start;
    }

    .content {
      @apply max-w-md ml-24 mr-0 mt-10 p-16 w-4/6;
    }

    .content > div {
      @apply block;
    }

    hr {
      @apply block my-16;
    }

    p {
      @apply p-0;
    }

    .bg {
      padding-bottom: 40%;
      @apply w-full mb-0 -ml-16 mt-20 mr-32;
    }
  }
</style>
